'use client';

import React, { useState } from 'react';
import { PartnerInquiryModal } from './PartnerInquiryModal';

interface PartnerInquiryButtonProps {
  buttonText: string;
  modalLabels: {
    title: string;
    subtitle: string;
    name: string;
    namePlaceholder: string;
    email: string;
    emailPlaceholder: string;
    website: string;
    websitePlaceholder: string;
    country: string;
    countryPlaceholder: string;
    submit: string;
    submitting: string;
    successTitle: string;
    successMessage: string;
    errorTitle: string;
    errorMessage: string;
    close: string;
  };
}

export function PartnerInquiryButton({ buttonText, modalLabels }: PartnerInquiryButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="inline-block bg-primary-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-primary-550 transition-colors"
      >
        {buttonText}
      </button>
      
      <PartnerInquiryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        labels={modalLabels}
      />
    </>
  );
}

